import { ToastPosition, ToastType } from '@space-lib-events/toast/enum'
import { toastEventDispatch } from '@space-lib-events/toast'
import i18n from 'src/i18n'
import { useCustomEvent } from 'src/hook/useCustomEvent'
import { FeedEventNames } from 'src/hook/usePosts'
import useBlockCommentsMutation from '../useBlockCommentsMutation/useBlockCommentsMutation'
import { OnConfirmButtonParams } from '../useBlockCommentsMutation/useBlockCommentsMutation.types'
import { BlockCommentsLabels, UnblockCommentsLabels } from '../../blockCommentsModal.constants'

const useBlockComments = (onClose: () => void) => {
  const {
    blockCommentsMutation: { mutate, isLoading }
  } = useBlockCommentsMutation()
  const { emitEvent } = useCustomEvent()

  const onConfirmButton = ({ post, isCommentsEnabled }: OnConfirmButtonParams) => {
    const { errorToast, successToast } = isCommentsEnabled
      ? BlockCommentsLabels
      : UnblockCommentsLabels

    mutate(
      { postId: post.id, isCommentsEnabled },
      {
        onSuccess: () => {
          const feedEvent = isCommentsEnabled
            ? FeedEventNames.COMMENT_BLOCKED
            : FeedEventNames.COMMENT_UNBLOCKED

          emitEvent(feedEvent, {
            postId: post.id,
            isPinnedPost: Boolean(post.isFixed),
            payload: {
              ...post,
              isCommentsEnabled: !post.isCommentsEnabled
            }
          })

          toastEventDispatch({
            type: ToastType.SUCCESS,
            message: i18n.t(successToast),
            position: ToastPosition.BOTTOM_RIGHT
          })

          onClose()
        },
        onError: () => {
          toastEventDispatch({
            type: ToastType.DANGER,
            message: i18n.t(errorToast),
            position: ToastPosition.BOTTOM_RIGHT
          })
        }
      }
    )
  }

  return { onConfirmButton, isLoading }
}

export default useBlockComments
